import Vue from 'vue';
import { ApiCorpMethods } from './http-methods';
import { ApiMethods } from '../http-methods';

let base64 = require('js-base64').Base64;

function getStore () {
  return Vue.prototype.$storeInstance;
}

/**
 * 获取集团账号信息
 * @returns {Promise<any>}
 */

export function consoleProfile () {
  return new Promise(async (resolve, reject) => {
    try {
      let corpPr = await ApiMethods.ProfileController.profile({});
      corpPr.data.accountInfoVO && getStore().dispatch('setAuthUser', corpPr.data.accountInfoVO);
      !corpPr.data.accountInfoVO && getStore().dispatch('setAuthUser', null);
      if (corpPr.success && corpPr.data) {
        getStore().dispatch('setAllAuthUser', corpPr.data).then(() => {
          resolve(corpPr);
        }).catch(e => {
          reject({
            succes: false,
            err: e,
          });
        });
      }
    } catch (e) {
      reject({
        success: false,
        err: e,
      });
    }
  });
}

/**
 * 设置当前选中的用户
 * 切换用户时调用
 * @param userInfo
 * @returns {Promise<any>}
 */
export function setCurrentUser (userInfo) {
  return new Promise(async (resolve, reject) => {
    try {
      if (userInfo) {
        localStorage.setItem('last_login_corp_id', userInfo.corpUserId || '');
        let corpUserId = '';
        let tokenRes = {}, { allAuthUser } = await getStore().getters;
        //判断用户类型

        if (userInfo.corpUserId) {
          //集团用户
          corpUserId = userInfo.corpUserId;
          tokenRes = await getConsoleToken(corpUserId);
        } else if (allAuthUser.corpCreateFlag == 1) {
          if (allAuthUser.manCorpUser && allAuthUser.manCorpUser.corpUserId) {
            tokenRes = await getConsoleToken(allAuthUser.manCorpUser.corpUserId);
          }
        }
        if (tokenRes.success == false) {
          reject({
            success: false,
            err: '获取token失败',
          });
          return;
        }
        // dispatch返回promise对象，可以在返回后执行下面的操作
        await getStore().dispatch('setCurrentAuthUser', userInfo).then(() => {
          resolve({
            success: true,
            currentUser: userInfo,
          });
        }).catch(e => {
          reject({
            succes: false,
            err: e,
          });
        });
      } else {
        reject({
          succes: false,
          err: '无法获取用户信息',
        });
      }
    } catch (e) {
      reject({
        succes: false,
        err: e,
      });
    }
  });
}

/**
 * 设置默认的当前用户
 */
export function defaultSetCurrentUser () {
  return new Promise(async (resolve, reject) => {
    try {
      let localLoginId = localStorage.getItem('last_login_corp_id');
      let userInfo = getStore().getters.allAuthUser.accountInfoVO || {};
      let orgUserInfos = getStore().getters.allAuthUser.bindCorpUsers || [];
      if (localLoginId) {
        //集团账号
        for (let i = 0, length = orgUserInfos.length; i < length; i++) {
          if (localLoginId == orgUserInfos[i].corpUserId) {
            //匹配集团
            let res = await setCurrentUser(orgUserInfos[i]);
            if (res.success) {
              resolve(res);
            } else {
              reject(res);
            }
            return;
          }
        }
        // reject('未找到匹配用户，系统自动切换到默认用户');
        console.log('未找到匹配用户，系统自动切换到默认用户');
      }
      //个人、企业账号
      let resPer = await setCurrentUser(userInfo);
      if (resPer.success) {
        resolve(resPer);
      } else {
        reject(resPer);
      }

    } catch (e) {
      reject({
        success: false,
        err: e,
      });
    }
  });
}

/**
 * 获取集团接口需要的token
 * @param corpUserId
 * @returns {Promise<any>}
 */
export function getConsoleToken (corpUserId) {
  return new Promise(async (resolve, reject) => {
    try {
      let param = {
        corpUserId: corpUserId,
      };
      let tokenRes = await ApiCorpMethods.CorpController.getToken(param);
      if (tokenRes.success && tokenRes.data) {
        let token = base64.encode(JSON.stringify({ ct: tokenRes.data.token }));
        let consoleToken = {
          token: token,
          exipreLen: tokenRes.data.exipreLen,
          perms: tokenRes.data.perms,
        };
        await getStore().dispatch('setConsoleToken', consoleToken);
        await getStore().commit('UPDATE_AllTOKEN', { [corpUserId]: token }); // 更新allToken值
        resolve({
          success: true,
          type: 'implement',
        });
      } else {
        reject({
          success: tokenRes.success,
          err: tokenRes.description || '无法获取token',
        });
      }
    } catch (e) {
      reject({
        success: false,
        err: e,
      });
    }
  });
}

/**
 * 登录或刷新时，重新获取profile，重新设置currentUser（该方法会重新获取token）
 * @returns {Promise<any>}
 */
export function loginOrRefresh () {
  return new Promise(async (resolve, reject) => {
    try {
      //获取所有用户信息
      let profileRes = await consoleProfile();
      if (!profileRes.success) {
        reject(profileRes);
        return;
      }

      //默认设置当前用户
      let res = await defaultSetCurrentUser();
      if (!res.success) {
        reject(res);
        return;
      }
      resolve({
        success: true,
        msg: '重置profile和currentUser成功',
      });
    } catch (e) {
      reject({
        success: false,
        err: e,
      });
    }
  });
}

/**
 *  首页查询token，不存储
 * */
export function getCorpToken (corpUserId) {
  return new Promise(async (resolve, reject) => {
    try {
      let param = {
        corpUserId: corpUserId,
      };
      let tokenRes = await ApiCorpMethods.CorpController.getToken(param);
      if (tokenRes.success && tokenRes.data) {
        let token = base64.encode(JSON.stringify({ ct: tokenRes.data.token }));
        getStore().commit('UPDATE_AllTOKEN', { [corpUserId]: token }); // 更新allToken值
        // console.log('查询token',corpUserId,tokenRes.data.token,token)
        resolve({
          success: true,
          data: token
        });
      } else {
        reject({
          success: tokenRes.success,
          err: tokenRes.description || '无法获取token',
        });
      }
    } catch (e) {
      reject({
        success: false,
        err: e,
      });
    }
  });
}
/**
 * 20200811大改需求，新增切换账户功能，这里存储所有token,便于后面切换，token更新时间：每次进入首页或集团首页
 * @callback function
 * */
export function storeAllToken (callback) {
  // 存储账户及集团账户的token,以corpUserId作为唯一标志
  let allAuthUser = getStore().getters.allAuthUser
  let accountTokenObj = {} // 格式{corpUserId：token}
  let userCId = ''
  if (allAuthUser.corpCreateFlag == 1) { // 当前登录企业账户
    if (allAuthUser.manCorpUser && allAuthUser.manCorpUser.corpUserId) {
      userCId = allAuthUser.manCorpUser.corpUserId
      accountTokenObj[userCId] = getStore().getters.token
    }
  }

  if (allAuthUser.bindCorpUsers && allAuthUser.bindCorpUsers.length > 0) { // 集团账户
    allAuthUser.bindCorpUsers.map((item) => {
      item.corpUserId && (accountTokenObj[item.corpUserId] = '');
    })
  }
  let currentAuthUser = getStore().getters.currentAuthUser
  let filterArr = [userCId] // 需要过滤掉的id，不用重新获取token（不获取当前登录账户token）

  // 。。。。。。。。。。。。20201230 改版只保留一个首页（去掉集团首页）--（注释此段逻辑，切换到集团用户，仍然重新获取信息） start 。。。。。。。。。。。。
  // if(currentAuthUser && currentAuthUser.corpUserId){ // 当前为集团账户，此id不获取token
  //   filterArr.push(currentAuthUser.corpUserId)
  // }
  // 。。。。。。。。。。。。 end 。。。。。。。。。。。。

  let arr = []
  for (let corpUserId in accountTokenObj) {
    // 排除不需要重新获取token的id
    if (filterArr.indexOf(+corpUserId) > -1) continue
    // 其他的重新获取token
    let fn = new Promise(async (resolve, reject) => {
      try {
        getCorpToken(corpUserId).then((res) => {
          accountTokenObj[corpUserId] = res.data
          callback && callback({ corpUserId, token: res.data }) // 返回当前id和对应的token，用于查询信息,这里只更新集团账户token
          resolve({ success: true })
        }).catch((e) => {
          reject({
            success: false,
            err: e,
          });
        })
      } catch (e) {
        reject({
          success: false,
          err: e,
        });
      }
    })
    arr.push(fn)
  }
  Promise.all(arr).then(values => {
    console.log('存储所有token')
    // 存储所有token
    getStore().commit('SET_AllTOKEN', accountTokenObj);
  });
}


/**
 *  标准版-切换为登录账户-【注意：需要控制台里面也支持请扩展此方法】
 * */
export function changeLgAccount () {
  return new Promise(async (resolve, reject) => {
    try {
      let loginAccount = getStore().getters.allAuthUser.accountInfoVO
      let currentAccount = getStore().getters.currentAuthUser
      if (currentAccount.superFlag !== undefined) { // 不是登录账户-切换为登录账户
        getStore().dispatch('setIgnoreChangePage', true) // 关闭切换重定向
        setCurrentUser(loginAccount).then(() => {
          getStore().dispatch('setIgnoreChangePage', false)
          resolve({ succes: true })
        }).catch((e) => {
          getStore().dispatch('setIgnoreChangePage', false)
          reject({
            succes: false,
            err: e,
          });
        })

      } else {
        resolve({ succes: true })
      }

    } catch (e) {
      reject({
        succes: false,
        err: e,
      });
    }
  });
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/corp/common.js